<template>
  <slot />
</template>

<script lang="ts">
export default {
  name: 'GridEmptyWrapper',
  inheritAttrs: false,
}
</script>
